import type { InjectionKey } from 'vue'

export interface ScrollbarContext {
  scrollbarElement: HTMLDivElement
  wrapElement: HTMLDivElement
}

export const ScrollbarContextKey: InjectionKey<ScrollbarContext> = Symbol('ScrollbarContextKey')
